import * as React from "react";
import { useState } from "react";
import { I } from "../redesign/kvpIcons";
import "./kontaktVorgaenge.css";

/**
 * Ein aufklappbarer Abschnitt „Vorgänge zu <Kontaktname>" (PO 08.09.2026:
 * „je indirekte Ebene (kann man ein- und ausklappen), dann schreiben
 * ‚Vorgänge zu (Kontaktname)‘").
 *
 * Er startet OFFEN: die indirekten Vorgänge sind der Grund, warum es diese
 * Ebenen überhaupt gibt — zugeklappt müsste man erst suchen, was man sehen
 * wollte.
 *
 * AUSNAHME seit dem 21.09.2026: der UNTERNEHMENSVERBUND einer Person. Seit
 * der Verbund auch am Ansprechpartner hängt, können das bei einem Konzern
 * zwei Dutzend Abschnitte sein — offen wäre das eigene Unternehmen darüber
 * nicht mehr zu finden. Zugeklappt bleibt die Zahl in der Kopfzeile sichtbar,
 * man sieht also, DASS dort etwas liegt, ohne es durchscrollen zu müssen.
 */
export const BezugsAbschnitt: React.FC<{
    kontaktName: string;
    anzahl: number;
    /** Ebenen-Überschrift, nur über dem ERSTEN Abschnitt einer Ebene. */
    ebeneTitel?: string;
    /** Zugeklappt starten — für die potenziell große Verbund-Ebene. */
    startZu?: boolean;
    children: React.ReactNode;
}> = ({ kontaktName, anzahl, ebeneTitel, startZu = false, children }) => {
    const [offen, setOffen] = useState(!startZu);

    return (
        <div className="kvg-abschnitt">
            {ebeneTitel && <span className="kvg-ebene">{ebeneTitel}</span>}
            <button
                type="button"
                className="kvg-abschnitt-h"
                aria-expanded={offen}
                onClick={() => setOffen((o) => !o)}
            >
                <span className={"kvg-chev" + (offen ? " open" : "")}>{I.chevD}</span>
                Vorgänge zu {kontaktName}
                <span className="kvg-zahl">{anzahl}</span>
            </button>
            {offen && children}
        </div>
    );
};
